// extracted by mini-css-extract-plugin
module.exports = {"icobtn__wrapper":"style_icobtn__wrapper__2LaRk"};